module.exports = [
	{
		"id": "20251030",
		"content": "October 2025 dataset. Data from Social Justice Funds added to Company Lists and Fund Results. Company list updates: Fossil Free Funds \"Carbon Underground 200\" list updated to use latest Fossil Free Indexes data (2025 Q2). "
	},
	{
		"id": "20250915",
		"content": "September 2025 dataset. Company list updates: Gender Equality Funds updated to use latest Equileap company data (2025 Q3). Gun Free Funds \"Civilian Firearm Manufacturer\" and \"Civilian Firearm Retailer\" screens updated to use most recent civilian firearms exclusion screen data from ANZ, NZ Super Fund, and Robeco. Weapon Free Funds \"Military Contractors\", \"Nuclear Weapons\", and \"Controversial Weapons\" screens updated to use most recent military weapon exclusion screen data from ABN Amro, ANZ, AP Pension, AP7, APB, Australian Government Future Fund, CB Fonder, Defense News, DNB Asset Management, Jyske Bank, KBC, KLP, Lægernes, Nordea, Norges Bank Investment Management, NZ Super Fund, PAX ICAN, Robeco, SBZ Pensioen, Schroders, and Storebrand."
	},
	{
		"id": "20250818",
		"content": "August 2025 dataset"
	},
	{
		"id": "20250723",
		"content": "July 2025 dataset. Company list updates: Fossil Free Funds \"Carbon Underground 200\" list updated to use latest Fossil Free Indexes data (2025 Q2). Fossil Free Funds \"Macroclimate 50\" screen updated to use latest Macroclimate data (2025). Fossil Free Funds \"fossil fuel finance\" screen updated to use latest Banking on Climate Chaos data (2025). Fossil Free Funds fossil fuel insurance screen updated to use latest Insure Our Future data (2024)."
	},
	{
		"id": "20250620",
		"content": "June 2025 dataset. Company list updates: Gender Equality Funds updated to use latest Equileap company data (2025 Q2)."
	},
	{
		"id": "20250508",
		"content": "May 2025 dataset. Company list updates: Fossil Free Funds \"Carbon Underground 200\" list updated to use latest Fossil Free Indexes data (2025 Q1)."
	},
	{
		"id": "20250416",
		"content": "April 2025 dataset. Company list updates: Weapon Free Funds \"Military Contractors\" screen updated to use most recent exclusion screen data from KLP."
	},
	{
		"id": "20250319",
		"content": "March 2025 dataset. Company list updates: Gender Equality Funds updated to use latest Equileap company data (2025 Q1)."
	},
	{
		"id": "20250303",
		"content": "February 2025 dataset. Company list updates: Fossil Free Funds \"Clean200™\" screen updated to use latest Corporate Knights data (Feb 2025). Prison Free Funds prison industry and border industry screens updated to use latest American Friends Service Committee data (Oct 2024). Weapon Free Funds \"Military Contractors\", \"Nuclear Weapons\", and \"Controversial Weapons\" screens updated to use most recent exclusion screen data from AP7, ABN Amro, ABP, Australia Future Fund, BankInvest, CB Fonder, DNB Asset Management, Jyske Bank, KLP, Laegernes Pension & Bank, Nordea Asset Management, Norges Bank Investment Management, NZ Super Fund, Robeco Institutional Asset Management, andSBZ Pensioen."
	},
	{
		"id": "20250129",
		"content": "January 2025 dataset. Company list updates: Fossil Free Funds \"Carbon Underground 200\" screen updated to use latest Fossil Free Indexes data (2024 Q4). Fossil Free Funds coal industry and fossil-fired utilities screens updated to use latest Global Coal Exit List data (2024). Fossil Free Funds oil/gas industry screen updated to use latest Global Oil/Gas Exit List data (2024). Weapon Free Funds \"Military Contractors\" screen updated to use most recent exclusion screen data from SIPRI Arms Industry Database (2023) and Defense News Top 100 Defense Companies (2024)."
	},
	{
		"id": "20241212",
		"content": "December 2024 dataset. Company list updates: Gender Equality Funds updated to use latest Equileap company data (2024 Q4)."
	},
	{
		"id": "20241114",
		"content": "November 2024 dataset."
	},
	{
		"id": "20241018",
		"content": "October 2024 dataset. Company list updates: Fossil Free Funds \"Carbon Underground 200\" screen updated to use latest Fossil Free Indexes data (2024 Q3)."
	},
	{
		"id": "20240925",
		"content": "September 2024 dataset. Company list updates: Gender Equality Funds updated to use latest Equileap company data (2024 Q3). Prison Free Funds prison industry and border industry screens updated to use latest American Friends Service Committee data (July 2024)."
	},
	{
		"id": "20240812",
		"content": "August 2024 dataset."
	},
	{
		"id": "20240723",
		"content": "July 2024 dataset. Company list updates: Fossil Free Funds \"Carbon Underground 200\" screen updated to use latest Fossil Free Indexes data (2024 Q2). Fossil Free Funds \"Macroclimate 50\" screen updated to use latest Macroclimate data (2024). Fossil Free Funds \"fossil fuel finance\" screen updated to use latest Banking on Climate Chaos data (2024)."
	},
	{
		"id": "20240613",
		"content": "June 2024 dataset. Company list updates: Gender Equality Funds updated to use latest Equileap company data (2024 Q2)."
	},
	{
		"id": "20240531",
		"content": "May 2024 dataset. Company list updates: Weapon Free Funds \"Military Contractors\", \"Nuclear Weapons\", and \"Controversial Weapons\" screens updated to use most recent exclusion screen data from ethical investment firms, and to use latest SIPRI Arms Industry Database (2022). Gun Free Funds \"Civilian Firearm Manufacturers\" and \"Civilian Firearm Retailers\" screens updated to use most recent exclusion screen data from ethical investment firms."
	},
	{
		"id": "20240426",
		"content": "April 2024 dataset. Company list updates: Fossil Free Funds \"Carbon Underground 200\" screen updated to use latest Fossil Free Indexes data (2024 Q1). Prison Free Funds prison industry and border industry screens updated to use latest American Friends Service Committee data (Apr 2024)."
	},
	{
		"id": "20240330",
		"content": "March 2024 dataset. Company list updates: Gender Equality Funds updated to use latest Equileap company data (2024 Q1)."
	},
	{
		"id": "20240215",
		"content": "February 2024 dataset. Company list updates: Fossil Free Funds \"Clean200™\" screen updated to use latest Corporate Knights data (2024). Fossil Free Funds \"Carbon Underground 200\" screen updated to use latest Fossil Free Indexes data (2023 Q4). Prison Free Funds prison industry and border industry screens updated to use latest American Friends Service Committee data (Jan 2024)."
	},
	{
		"id": "20240113",
		"content": "January 2024 dataset."
	},
	{
		"id": "20240105",
		"content": "December 2023 dataset. Company list updates: Fossil Free Funds coal industry and fossil-fired utilities screens updated to use latest Global Coal Exit List data (2023). Fossil Free Funds oil/gas industry screen updated to use latest Global Oil/Gas Exit List data (2023). Gender Equality Funds updated to use latest Equileap company data (2023 Q4)."
	},
	{
		"id": "20231116",
		"content": "November 2023 dataset. Company list updates: Fossil Free Funds \"Carbon Underground 200\" screen updated to use latest Fossil Free Indexes data (2023 Q3). Prison Free Funds prison industry and border industry screens updated to use latest American Friends Service Committee data (Oct 2023)."
	},
	{
		"id": "20231006",
		"content": "October 2023 dataset."
	},
	{
		"id": "20230924",
		"content": "September 2023 dataset. Company list updates: Gender Equality Funds updated to use latest Equileap company data (2023 Q3)."
	},
	{
		"id": "20230914",
		"content": "August 2023 dataset. Company list updates: Fossil Free Funds \"Carbon Underground 200\" screen updated to use latest Fossil Free Indexes data (2023 Q2)."
	},
	{
		"id": "20230718",
		"content": "July 2023 dataset. Company list updates: Weapon Free Funds \"Military Contractors\", \"Nuclear Weapons\", and \"Controversial Weapons\" screens updated to incorporate exclusion screen data from over a dozen ethical investment firms, and to use latest SIPRI Arms Industry Database (2021)."
	},
	{
		"id": "20230613",
		"content": "June 2023 dataset. Company list updates: Gender Equality Funds updated to use latest Equileap company data (2023 Q2). Prison Free Funds prison industry and border industry screens updated to use latest American Friends Service Committee data (Jun 2023)."
	},
	{
		"id": "20230506",
		"content": "May 2023 dataset."
	},
	{
		"id": "20230415",
		"content": "April 2023 dataset. Company list updates: Fossil Free Funds \"Carbon Underground 200\" screen updated to use latest Fossil Free Indexes data (2023 Q1). Fossil Free Funds \"fossil fuel finance\" screen updated to use latest Banking on Climate Chaos data (2023)."
	},
	{
		"id": "20230407",
		"content": "April 2023 dataset."
	},
	{
		"id": "20230309",
		"content": "March 2023 dataset. Company list updates: Gender Equality Funds updated to use latest Equileap company data (2023 Q1)."
	},
	{
		"id": "20230224",
		"content": "February 2023 dataset. Company list updates: Fossil Free Funds \"Clean200™\" screen updated to use latest Corporate Knights data (2023)."
	},
	{
		"id": "20230208",
		"content": "February 2023 dataset."
	},
	{
		"id": "20230127",
		"content": "January 2023 dataset. Company list updates: Fossil Free Funds \"Carbon Underground 200\" screen updated to use latest Fossil Free Indexes data (2022 Q4). Gun Free Funds civilian firearm manufacturer and civilian firearm retailer screens updated. Weapon Free Funds screens updated to remove several companies no longer included on SIPRI Arms Industry Database."
	},
	{
		"id": "20221216",
		"content": "December 2022 dataset. Company list updates: Fossil Free Funds coal industry and fossil-fired utilities screens updated to use latest Global Coal Exit List data (2022). Fossil Free Funds oil/gas industry screen updated to use latest Global Oil/Gas Exit List data (2022). Gender Equality Funds updated to use latest Equileap company data (2022 Q4)."
	},
	{
		"id": "20221109",
		"content": "November 2022 dataset. Company list updates: Fossil Free Funds \"Carbon Underground 200\" screen updated to use latest Fossil Free Indexes data (2022 Q3). Fossil Free Funds fossil fuel insurance screen updated to use latest Insure Our Future data (2022)."
	},
	{
		"id": "20221019",
		"content": "October 2022 dataset."
	},
	{
		"id": "20220914",
		"content": "September 2022 dataset. Company list updates: Fossil fuel finance and insurance screens added to Fossil Free Funds. Gender Equality Funds updated to use latest Equileap company data (2022 Q3). Tobacco Free Funds \"Tobacco producers\" screen updated to use latest Morningstar industry data."
	},
	{
		"id": "20220808",
		"content": "August 2022 dataset. Company list updates: Fossil Free Funds \"Carbon Underground 200\" screen updated to use latest Fossil Free Indexes data (2022 Q2). Fossil Free Funds \"Macroclimate 30\" screen updated to use latest Macroclimate data (2022)."
	},
	{
		"id": "20220715",
		"content": "July 2022 dataset. Company list updates: Prison Free Funds prison industry and border industry screens updated to use latest American Friends Service Committee data (Jul 2022)."
	},
	{
		"id": "20220614",
		"content": "June 2022 dataset. Company list updates: Fossil Free Funds \"Carbon Underground 200\" screen updated to use latest Fossil Free Indexes data (2022 Q1). Gender Equality Funds updated to use latest Equileap company data (2022 Q2)."
	},
	{
		"id": "20220511",
		"content": "May 2022 dataset. Company list updates: Prison Free Funds prison industry and border industry screens updated to use latest American Friends Service Committee data (Apr 2022)."
	},
	{
		"id": "20220411",
		"content": "April 2022 dataset."
	},
	{
		"id": "20220316",
		"content": "March 2022 dataset. Company list updates: Gender Equality Funds updated to use latest Equileap company data (2022 Q1). Prison Free Funds prison industry and border industry screens updated to use latest American Friends Service Committee data (Jan 2022). Gun Free Funds civilian firearm manufacturer and civilian firearm retailer screens updated."
	},
	{
		"id": "20220216",
		"content": "February 2022 dataset. Company list updates: Fossil Free Funds \"Clean200™\" screen updated to use latest Corporate Knights data (2022)."
	},
	{
		"id": "20220209",
		"content": "February 2022 dataset. Company list updates: Fossil Free Funds \"Carbon Underground 200\" screen updated to use latest Fossil Free Indexes data (2021 Q4)."
	},
	{
		"id": "20220125",
		"content": "January 2022 dataset."
	},
	{
		"id": "20211214",
		"content": "December 2021 dataset. Company list updates: Fossil Free Funds oil/gas industry screen updated to use latest Global Oil/Gas Exit List data (2021). Gender Equality Funds updated to use latest Equileap company data (2021 Q4)."
	},
	{
		"id": "20211113",
		"content": "November 2021 dataset. Company list updates: Fossil Free Funds \"Carbon Underground 200\" screen updated to use latest Fossil Free Indexes data (2021 Q3)."
	},
	{
		"id": "20211029",
		"content": "October 2021 dataset. Company list updates: Additional updates to Prison Free Funds prison industry and border industry screens using use latest American Friends Service Committee data. Companies no longer on latest Global Coal Exit List data (2021) removed from Fossil Free Funds coal industry and fossil-fired utilities screens."
	},
	{
		"id": "20211019",
		"content": "October 2021 dataset. Company list updates: Fossil Free Funds coal industry and fossil-fired utilities screens updated to use latest Global Coal Exit List data (2021). Prison Free Funds prison industry and border industry screens updated to use latest American Friends Service Committee data."
	},
	{
		"id": "20210909",
		"content": "September 2021 dataset. Company list updates: Gender Equality Funds updated to use latest Equileap company data (2021 Q3)."
	},
	{
		"id": "20210902",
		"content": "August 2021 dataset. Target date funds added to dataset. Fossil Free Funds \"Macroclimate 30\" screen updated to use latest Macroclimate data (2021)."
	},
	{
		"id": "20210809",
		"content": "July 2021 dataset. Company list updates: Fossil Free Funds \"Carbon Underground 200\" screen updated to use latest Fossil Free Indexes data (2021 Q2). Gender Equality Funds updated to use latest Equileap company data (2021 Q2)."
	},
	{
		"id": "20210715",
		"content": "June 2021 dataset."
	},
	{
		"id": "20210503",
		"content": "April 2021 dataset. Company list updates: Fossil Free Funds \"Carbon Underground 200\" screen updated to use latest Fossil Free Indexes data (2021 Q1). Fossil Free Funds coal industry and fossil-fired utilities screens updated to use latest Global Coal Exit List data (2020). Gender Equality Funds updated to use latest Equileap company data (2021 Q1)."
	},
	{
		"id": "20210401",
		"content": "March 2021 dataset."
	},
	{
		"id": "20210303",
		"content": "February 2021 dataset. Company list updates: Fossil Free Funds \"Clean200™\" screen updated to use latest Corporate Knights data (2021)."
	},
	{
		"id": "20210121",
		"content": "January 2021 dataset. Screen list and fund results updates: Fossil Free Funds \"Carbon Underground 200\" screen updated to use latest Fossil Free Indexes data (2020 Q4). Gender Equality Funds updated to use latest Equileap company data (2020 Q4). Fund exposure formula and grading methodologies updated; see \"Updating rating methodologies\" on the Fossil Free Funds blog."
	},
	{
		"id": "20201111",
		"content": "November 2020 dataset. Screen list and fund results updates: Fossil Free Funds \"Carbon Underground 200\" screen updated to use latest Fossil Free Indexes data (2020 Q3). \"Sustainability Mandate\" label updated to use new Morningstar sustainable investment taxonomy."
	},
	{
		"id": "20201018",
		"content": "October 2020 dataset."
	},
	{
		"id": "20200928",
		"content": "September 2020 dataset. Screen list and fund results updates: Gender Equality Funds updated to use latest Equileap company data, covering 19 criteria and four sub-scores."
	},
	{
		"id": "20200913",
		"content": "September 2020 dataset. Company list updates: Tobacco Free Funds \"Tobacco-promoting entertainment companies\" screen updated to use latest UCSF Smoke Free Movies Campaign data."
	},
	{
		"id": "20200811",
		"content": "August 2020 dataset. Company list updates: Prison Free Funds screens added. Tobacco Free Funds \"Tobacco producers\" screen updated to use latest Morningstar industry data."
	},
	{
		"id": "20200716",
		"content": "July 2020 dataset. Company list updates: Fossil Free Funds \"Carbon Underground 200\" screen updated to use latest Fossil Free Indexes data (2020 Q2). Fossil Free Funds \"Macroclimate 30\" screen updated to use latest Macroclimate data (2020)."
	},
	{
		"id": "20200610",
		"content": "June 2020 dataset."
	},
	{
		"id": "20200519",
		"content": "May 2020 dataset. Company list updates: Fossil Free Funds \"Carbon Underground 200\" screen updated to use latest Fossil Free Indexes data (2020 Q1)."
	},
	{
		"id": "20200414",
		"content": "April 2020 dataset. Company list updates: Weapon Free Funds \"Major Military Contractors\" screen updated to use latest SIPRI Arms Industry Database (2018)."
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/Changelog.json
// module id = 957
// module chunks = 0